"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serve = exports.run = exports.sendError = exports.send = void 0;
const http_1 = require("http");
const content_type_1 = __importDefault(require("content-type"));
const errors_1 = require("./errors");
const { NODE_ENV } = process.env;
const DEV = NODE_ENV === 'development';
const jsonStringify = DEV
    ? (obj) => JSON.stringify(obj, null, 2)
    : (obj) => JSON.stringify(obj);
const isStream = (data) => !!data && typeof data.pipe === 'function';
function send(res, statusCode, obj = null) {
    res.statusCode = statusCode;
    if (obj === null) {
        res.end();
        return;
    }
    if (Buffer.isBuffer(obj)) {
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/octet-stream');
        }
        res.setHeader('Content-Length', obj.length);
        res.end(obj);
        return;
    }
    if (isStream(obj)) {
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/octet-stream');
        }
        obj.pipe(res);
        return;
    }
    let str = obj;
    const typeObj = typeof obj;
    if (typeObj === 'object' || typeObj === 'number' || typeObj === 'boolean') {
        str = jsonStringify(obj);
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'application/json; charset=utf-8');
        }
    }
    else {
        if (!res.getHeader('Content-Type')) {
            res.setHeader('Content-Type', 'text/plain; charset=utf-8');
        }
    }
    res.setHeader('Content-Length', Buffer.byteLength(str));
    res.end(str);
}
exports.send = send;
function isAcceptJson(headers) {
    const { accept } = headers;
    let type = '*/*';
    try {
        const ct = content_type_1.default.parse(accept || type);
        type = ct.type || '*/*';
    }
    catch (err) {
    }
    return type === '*/*' || accept === 'application/json';
}
const sendError = (req, res, errorObj) => {
    const acceptJson = isAcceptJson(req.headers);
    let statusCode = 500;
    let body = acceptJson
        ? {
            error: {
                code: 'internal_server_error',
                message: 'Internal Server Error',
            },
        }
        : 'Internal Server Error';
    if (errorObj instanceof errors_1.MicriError) {
        statusCode = errorObj.statusCode || 500;
        const code = errorObj.code || 'internal_server_error';
        if (acceptJson) {
            if (DEV) {
                body = {
                    error: {
                        code,
                        message: errorObj.message,
                        stack: errorObj.stack,
                        originalError: errorObj.originalError || null,
                    },
                };
            }
            else {
                const message = errorObj.message || 'Internal Server Error';
                body = {
                    error: {
                        code,
                        message,
                    },
                };
            }
        }
        else {
            const message = errorObj.message || 'Internal Server Error';
            body = DEV ? errorObj.stack : message;
        }
    }
    else if (errorObj instanceof Error) {
        console.error(errorObj);
    }
    else {
        console.warn('thrown error must be an instance Error');
    }
    send(res, statusCode, body);
};
exports.sendError = sendError;
function run(req, res, fn) {
    return new Promise((resolve) => resolve(fn(req, res)))
        .then((val) => {
        if (val === null) {
            send(res, 204, null);
            return;
        }
        if (val !== undefined) {
            send(res, res.statusCode || 200, val);
        }
    })
        .catch((err) => (0, exports.sendError)(req, res, err));
}
exports.run = run;
const serve = (fn) => (0, http_1.createServer)((req, res) => run(req, res, fn));
exports.serve = serve;
//# sourceMappingURL=data:application/json;base64,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